import React, { useState } from "react";
import { Eye, EyeOff, Lock } from "lucide-react";

const inputClass =
  "w-full bg-black/60 border border-white/15 rounded-md pl-10 pr-10 py-2.5 text-sm text-spike-text placeholder:text-spike-dim focus:outline-none focus:border-spike-blue";

const PasswordInput = ({
  value,
  onChange,
  placeholder,
  "data-testid": testId,
  minLength,
  required = false,
  className = "",
}) => {
  const [visible, setVisible] = useState(false);

  return (
    <div className="relative">
      <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-spike-dim pointer-events-none" />
      <input
        type={visible ? "text" : "password"}
        required={required}
        minLength={minLength}
        placeholder={placeholder}
        data-testid={testId}
        value={value}
        onChange={onChange}
        className={`${inputClass} ${className}`.trim()}
      />
      <button
        type="button"
        onClick={() => setVisible((v) => !v)}
        aria-label={visible ? "Hide password" : "Show password"}
        aria-pressed={visible}
        data-testid={testId ? `${testId}-toggle` : undefined}
        className="absolute right-3 top-1/2 -translate-y-1/2 text-spike-dim hover:text-spike-text transition-colors"
      >
        {visible ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
      </button>
    </div>
  );
};

export default PasswordInput;
